export default __webpack_public_path__ + "locales/vi/SharingPanel.json?hash=ec9092abba4df8211805ad5019bb7ca1";